module Visonum.BulkPingApp.App.Header
  ( view
  ) where

import Visonum.BulkPingApp.Prelude

import Halogen.HTML.Elements as H
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Visonum.BulkPingApp.Components.App.Types (Action(..), LogInState(..), State)
import Visonum.BulkPingApp.Imgs (imgBmpLogo, imgLogout, imgVfLogo)

view :: forall w. State -> AppHTML w Action
view state =
  let
    elRoot = styleNode H.div
      "Header"
      [ inline
          { display: "flex"
          , flexDirection: "row"
          , justifyContent: "space-between"
          , alignItems: "center"
          , width: "100%"
          , height: "100%"
          , padding: "15px"
          }
      ]

    elLogo = styleNode H.div
      "Logo"
      [ inline
          { display: "flex"
          , flexDirection: "row"
          , gap: "10px"
          , alignItems: "center"
          }
      ]

    elVfLogo = styleLeaf H.img
      "VfLogo"
      [ inline
          { width: "40px"
          , height: "40px"
          }
      ]

    elBmpLogo = styleLeaf H.img
      "BmpLogo"
      [ inline
          { height: "30px"
          , justifySelf: "start"
          , flex: "1"
          }
      ]

    elLogoutIcon = styleLeaf H.img
      "Logout"
      [ inline
          { width: "40px"
          , height: "40px"
          , cursor: "pointer"
          , borderRadius: "50%"
          , padding: "10px"
          }
      , scopedSheet $ select ":hover" { backgroundColor: "rgba(0,0,0,0.05)" }
      ]

  in

    elRoot
      [ HE.onClick $ const $ HideDetails ]
      [ elLogo []
          [ elVfLogo
              [ HP.src imgVfLogo
              ]
          , elBmpLogo
              [ HP.src imgBmpLogo
              ]
          ]
      , if state.logInState == LoginSuccess then
          elLogoutIcon
            [ HE.onClick $ const Logout
            , HP.src imgLogout
            ]
        else text ""
      ]
